<template>
    
    <div class="container">
        <div class="row col-12 mx-auto my-5">
            <h2 class="mt-5" style="font-weight: bold;">About Us</h2>
            <h5 class="mt-4">What is Nabucco and how does it work?</h5>
            <h5 class="mt-3">
                Nabaku Financial Artificial Intelligence Company, as one of the leading companies in the country in using artificial intelligence and mathematical intelligence models in the country's financial industry, began its activities in 1400.
                <br>
                Nabuco Artificial Intelligence has also been active internationally by carrying out various projects in the financial industry and collaborating in the excellence and advancement of the real use of artificial intelligence as an applied tool in the financial industry, and has had extensive cooperation with countries bordering the Persian Gulf, Europe, and North America.
                <br>
                <br>
                The use of artificial intelligence tools as a predictor with high and accurate coefficients, very high data reading, and advanced mathematical intelligence processing power has greatly helped its investors achieve financial success.
            </h5>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <div class="col-lg-6 text-start pt-5">
                        <h2 class="fw-bold">Our mission</h2>
                        <h5 class="mt-3">
                            Nabaku AI has now made it possible for its users to use AI, and investors can use this tool as a suitable investment assistant. Our mission at Nabaku AI is to use descriptive AI in the country's financial industry, which can be considered a huge leap in this industry.
                        </h5>
                    </div>
                    <div class="col-lg-4 my-auto text-end">
                        <img src="../../assets/test/mission.svg" class="w-75" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <div class="col-lg-4 my-auto text-start">
                        <img src="../../assets/services-img/img16.svg" class="w-75" alt="">
                    </div>
                    <div class="col-lg-6 text-start pt-5">
                        <h2 class="fw-bold">Outlook</h2>
                        <h5 class="mt-3">
                            Nabaku Artificial Intelligence, as one of the leading companies in the field of the correct use of mathematical models, algorithms, and applied artificial intelligence in industries, is making every effort to optimize its algorithms so that investors can achieve maximum profits and experience investment security with ease and confidence.
                        </h5>
                    </div>
                </div>
            </div>
            <div class="row col-md-9 mx-auto">
                <div class="col-md-6">
                    <div>
                        <img src="../../../public/img/HosseinMalekinezhad.png" width="100%" alt="">
                    </div>
                </div>
                <div class="col-md-6 my-auto">
                    <div class="text-start px-5">
                        <h3>Dr. Hossein Malekinejad</h3>
                        <h5>Chairman of the Board</h5>
                        <h5>Experience as a Technology Manager for Banking Technologies</h5>
                        <h5>PhD in Artificial Intelligence and Machine Learning</h5>
                        <h5>Launching Forecasting Systems in the Financial Industry</h5>
                    </div>
                </div>
                
                <div class="col-md-6 my-auto">
                    <div class="text-start px-5">
                        <h3>Hossein Moezin</h3>
                        <h5>CEO</h5>
                        <h5>Master of Strategy Management</h5>
                        <h5>Experience in launching smart systems in the oil, gas and petrochemical industries</h5>
                        <h5>Consulting and launching systems based on artificial intelligence and the Internet of Things</h5>
                        <h5>Starting up new businesses in Iran and North America</h5>
                    </div>
                </div>
                <div class="col-md-6">
                    <div>
                        <img src="../../../public/img/HoseinMoazen.png" width="100%" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style scoped>
*{
    direction: ltr;
}
</style>